/**
 * vape-product.js
 * CBD Vapeベイプ商品ページ専用スクリプト
 *
 * 依存関係: window.vapePage（sections/product-vape.liquid 内インラインスクリプトで定義）
 *
 * UI フロー:
 *   STEP1: CBD濃度選択（20% / 5%）
 *   STEP2: 購入タイプ選択（定期購入 / 単品購入）
 *   STEP3-A: 定期購入プラン選択（20本/月 · 12本/月 · 5本/月）
 *   STEP3-B: 単品数量カウンター（min:1 上限なし）
 *   STEP4: フレーバー選択（10種・カウンター形式）
 *   STEP5: 金額確認・カートに追加
 *
 * バリアント特定:
 *   濃度 × 購入タイプ × プランのSKUからvariantIdを動的解決
 *
 * 割引ロジック（単品購入のみ）:
 *   discountCount = Math.floor(qty / 6)
 *   合計金額 = 単価 × qty - 単価 × discountCount
 *   例: 6本→1本割引、7〜11本→1本割引、12本→2本割引
 *
 * カートAPI仮実装:
 *   /cart/add.js を使用（単品・定期共通）
 *   TODO: Mikawaya Subscription 連携時に定期購入部分を差し替える
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     SKU → 選択状態 マッピング
     キー形式: "{concentration}-{purchaseType}-{subPlan|0}"
  ------------------------------------------------------------------ */
  var MIKAWAYA_PLAN_ID = 3948544216;

  var SKU_MAP = {
    '20p-subscription-20': 'VAPE-20P-SUB-20',
    '20p-subscription-12': 'VAPE-20P-SUB-12',
    '20p-subscription-5':  'VAPE-20P-SUB-05',
    '20p-one_time-0':      'VAPE-20P-ONE',
    '05p-subscription-20': 'VAPE-05P-SUB-20',
    '05p-subscription-12': 'VAPE-05P-SUB-12',
    '05p-subscription-5':  'VAPE-05P-SUB-05',
    '05p-one_time-0':      'VAPE-05P-ONE',
  };

  /* ------------------------------------------------------------------
     定期購入 固定価格（円）
     キー形式: "{concentration}-{plan本数}"
  ------------------------------------------------------------------ */
  var VP = window.VAPE_PRICES || {};

  var SUB_PRICES = {
    '20p-20': VP['VAPE-20P-SUB-20'] || 29880,
    '20p-12': VP['VAPE-20P-SUB-12'] || 19880,
    '20p-5':  VP['VAPE-20P-SUB-05'] || 9880,
    '05p-20': VP['VAPE-05P-SUB-20'] || 13980,
    '05p-12': VP['VAPE-05P-SUB-12'] || 8480,
    '05p-5':  VP['VAPE-05P-SUB-05'] || 3680,
  };

  /* ------------------------------------------------------------------
     単品購入 単価（円）
     定期プランのお得額計算に使用
  ------------------------------------------------------------------ */
  var SINGLE_UNIT_PRICES = {
    '20p': VP['VAPE-20P-ONE'] || 3000,
    '05p': VP['VAPE-05P-ONE'] || 1100,
  };

  /* ------------------------------------------------------------------
     フレーバー設定マップ
     キー: metafield JSONのキーと一致
  ------------------------------------------------------------------ */
  var FLAVOR_CONFIG = {
    caramel:        { label: 'キャラメル' },
    mix_berry:      { label: 'ミックスベリー' },
    grape:          { label: 'グレープ' },
    strong_menthol: { label: 'ストロング<br>メンソール' },
    muscat:         { label: 'マスカット' },
    lychee:         { label: 'ライチ' },
    mango:          { label: 'マンゴー' },
    strawberry:     { label: 'ストロベリー' },
    green_apple:    { label: 'グリーン<wbr>アップル' },
    bear_mint:      { label: 'ベアミント' },
  };

  /* ------------------------------------------------------------------
     状態管理
  ------------------------------------------------------------------ */
  var state = {
    concentration: '05p',     // '20p' | '05p'  デフォルト: CBD 5%（2026-10-16 変更。左も5%）
    purchaseType:  'subscription', // 'subscription' | 'one_time'  デフォルト: 定期購入
    subPlan:       null,      // 20 | 12 | 5  （定期購入時のみ）
    quantity:      1,         // 単品購入時の本数
    variantId:     null,
    variantPrice:  0,         // 単価（Shopify最小単位: 円 × 100）
    variantAvailable: false,
    flavorCounts:  {},        // { flavor_key: number }
    stockData:     {},        // 現在の濃度に対応した在庫データ
  };

  /* ------------------------------------------------------------------
     ページデータ
  ------------------------------------------------------------------ */
  var PAGE     = window.vapePage || {};
  var variants = PAGE.variants  || [];

  /* ------------------------------------------------------------------
     ユーティリティ
  ------------------------------------------------------------------ */

  /** 価格を日本円表示に変換（Shopify単位: 円 × 100） */
  function formatMoney(cents) {
    return '<span class="price-currency">¥</span>' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }

  /**
   * 割引本数（単品購入のみ）
   * 6の倍数ちょうどで割引発生: Math.floor(qty / 6)
   */
  function getDiscountCount(qty) {
    return Math.floor(qty / 6);
  }

  /** 単品購入時の支払い合計 */
  function calcPayableTotal(qty, unitPrice) {
    return (qty - getDiscountCount(qty)) * unitPrice;
  }

  /** フレーバーの合計選択数 */
  function getFlavorSelectedCount() {
    return Object.keys(state.flavorCounts).reduce(function (sum, k) {
      return sum + (state.flavorCounts[k] || 0);
    }, 0);
  }

  /** 有効な注文数量（フレーバー選択上限）: 定期 = プラン本数 / 単品 = quantity */
  function getEffectiveQty() {
    if (state.purchaseType === 'subscription') return state.subPlan || 0;
    return state.quantity;
  }

  /**
   * カートAPIに渡す quantity
   * 定期購入はプラン1件 = quantity:1（プラン自体に本数が含まれる）
   * 単品購入は選択した本数そのまま
   */
  function getCartQty() {
    if (state.purchaseType === 'subscription') return 1;
    return state.quantity;
  }

  /**
   * 定期プランのお得額を計算（円）
   * （単品単価 × プラン本数）- プラン定期価格
   */
  function calcPlanSavings(plan) {
    var unitPrice = SINGLE_UNIT_PRICES[state.concentration] || 0;
    var subPrice  = SUB_PRICES[state.concentration + '-' + plan] || 0;
    return unitPrice * plan - subPrice;
  }

  /** プランカードの金額・お得額テキストを更新 */
  function renderPlanSavings() {
    [20, 12, 5].forEach(function (plan) {
      /* 金額更新 */
      var priceEl = document.querySelector('.vape-plan-price-value[data-plan="' + plan + '"]');
      if (priceEl) {
        var planPrice = SUB_PRICES[state.concentration + '-' + plan] || 0;
        priceEl.textContent = planPrice.toLocaleString('ja-JP');
      }

      /* お得額更新 */
      var el = document.querySelector('.vape-plan-savings[data-plan="' + plan + '"]');
      if (!el) return;
      var savings = calcPlanSavings(plan);
      el.innerHTML = savings > 0
        ? '通常比 <span class="vape-plan-savings-amount en"><span class="price-currency">¥</span>' + savings.toLocaleString('ja-JP') + '</span> お得'
        : '';
    });
  }

  /** 要素の表示/非表示（アニメーション付き） */
  function showStep(el) {
    if (!el) return;
    el.classList.remove('vape-step-hidden');
  }
  function hideStep(el) {
    if (!el) return;
    el.classList.add('vape-step-hidden');
  }

  /* ------------------------------------------------------------------
     SKU解決 → バリアント特定
  ------------------------------------------------------------------ */
  function resolveVariant() {
    if (!state.concentration || !state.purchaseType) return null;
    if (state.purchaseType === 'subscription' && !state.subPlan) return null;

    var planKey = state.purchaseType === 'subscription' ? String(state.subPlan) : '0';
    var mapKey  = state.concentration + '-' + state.purchaseType + '-' + planKey;
    var sku     = SKU_MAP[mapKey];
    if (!sku) return null;

    return variants.find(function (v) { return v.sku === sku; }) || null;
  }

  function applyResolvedVariant() {
    var variant = resolveVariant();
    if (variant) {
      state.variantId        = variant.id;
      state.variantPrice     = variant.price;
      state.variantAvailable = variant.available;
    } else {
      state.variantId        = null;
      state.variantPrice     = 0;
      state.variantAvailable = false;
    }
  }

  /** 濃度に応じた在庫データを切替 */
  function applyStockData() {
    if (state.concentration === '20p') {
      state.stockData = PAGE.stock20p || {};
    } else if (state.concentration === '05p') {
      state.stockData = PAGE.stock05p || {};
    } else {
      state.stockData = {};
    }
  }

  /* ------------------------------------------------------------------
     ギャラリー → assets/gallery.js に移行済み
  ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     STEP 1: CBD濃度選択
  ------------------------------------------------------------------ */
  function initConcentration() {
    var group = document.getElementById('vapeConcentrationGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var card = e.target.closest('.vape-radio-card');
      if (!card) return;

      var val = card.dataset.value;
      if (state.concentration === val) return;

      state.concentration = val;
      state.flavorCounts  = {};
      applyStockData();
      applyResolvedVariant();

      // ラジオUI更新
      group.querySelectorAll('.vape-radio-card').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === val);
        c.querySelector('input').checked = (c.dataset.value === val);
      });

      renderPlanSavings();
      renderQtyMotivation();
      renderFlavorGrid();
      renderFlavorSummary();
      renderPrice();
      renderAddToCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2: 購入タイプ選択
  ------------------------------------------------------------------ */
  function initPurchaseType() {
    var group = document.getElementById('vapePurchaseTypeGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var card = e.target.closest('.vape-radio-card');
      if (!card) return;

      var val = card.dataset.value;
      if (state.purchaseType === val) return;

      state.purchaseType = val;
      state.subPlan      = null;
      state.quantity     = 1;
      state.flavorCounts = {};
      applyResolvedVariant();

      group.querySelectorAll('.vape-radio-card').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === val);
        c.querySelector('input').checked = (c.dataset.value === val);
      });

      // STEP3の切り替え：定期 ↔ 単品 で STEP3-A / STEP3-B を排他表示
      if (val === 'subscription') {
        showStep(document.getElementById('vapeStep3Sub'));
        hideStep(document.getElementById('vapeStep3One'));
        resetPlanButtons();
      } else {
        hideStep(document.getElementById('vapeStep3Sub'));
        showStep(document.getElementById('vapeStep3One'));
        var qtyInput = document.getElementById('vapeQtyInput');
        if (qtyInput) qtyInput.value = 1;
        var minusBtn = document.getElementById('vapeQtyMinus');
        if (minusBtn) minusBtn.disabled = true;
      }

      renderQtyMotivation();
      renderQtyDiscountBanner();
      renderFlavorGrid();
      renderFlavorSummary();
      renderPrice();
      renderAddToCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 3-A: 定期購入プラン選択
  ------------------------------------------------------------------ */
  function initSubPlan() {
    var group = document.getElementById('vapeSubPlanGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.vape-plan-btn');
      if (!btn) return;

      var plan = parseInt(btn.dataset.plan, 10);
      state.subPlan      = plan;
      state.flavorCounts = {};
      applyResolvedVariant();

      group.querySelectorAll('.vape-plan-btn').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.plan, 10) === plan);
      });

      onStep3Complete();
    });
  }

  /* ------------------------------------------------------------------
     STEP 3-B: 単品数量カウンター
  ------------------------------------------------------------------ */
  function initQuantity() {
    var minusBtn = document.getElementById('vapeQtyMinus');
    var plusBtn  = document.getElementById('vapeQtyPlus');
    var input    = document.getElementById('vapeQtyInput');
    if (!input) return;

    minusBtn && minusBtn.addEventListener('click', function () {
      if (state.quantity <= 1) return;
      state.quantity--;
      updateQuantityUI();
      trimFlavorCounts();
      onQuantityChanged();
    });

    plusBtn && plusBtn.addEventListener('click', function () {
      state.quantity++;
      updateQuantityUI();
      onQuantityChanged();
    });
  }

  function updateQuantityUI() {
    var input    = document.getElementById('vapeQtyInput');
    var minusBtn = document.getElementById('vapeQtyMinus');
    if (input)    input.value         = state.quantity;
    if (minusBtn) minusBtn.disabled   = state.quantity <= 1;
  }

  function onQuantityChanged() {
    applyResolvedVariant();
    renderQtyMotivation();
    renderQtyDiscountBanner();
    renderFlavorGrid();
    renderFlavorSummary();
    renderPrice();
    renderAddToCartState();
  }

  /**
   * STEP3-B 数量カウンター下の購買訴求プロモカード
   * pos（サイクル内位置）に応じて4種のメッセージを表示
   * 濃度切替時も discountAmount を再計算して更新
   */
  function renderQtyMotivation() {
    var el = document.getElementById('vapeQtyPromo');
    if (!el) return;

    if (state.purchaseType !== 'one_time') {
      el.style.display = 'none';
      return;
    }

    var count          = state.quantity;
    var unitPrice      = SINGLE_UNIT_PRICES[state.concentration] || 0;
    var cycle          = Math.ceil(count / 6);
    var pos            = ((count - 1) % 6) + 1;
    var remaining      = 6 - pos;
    var discountAmount = cycle * unitPrice;
    var amountSpan     = '<span class="vape-qty-promo-amount">(▲' + discountAmount.toLocaleString() + '円)</span>';

    var html;
    var modifier;

    if (pos <= 2) {
      html     = (cycle * 6) + '本購入で ' + cycle + '本分 ' + amountSpan + ' 割引！あと' + remaining + '本';
      modifier = '';
    } else if (pos <= 4) {
      html     = '割引' + amountSpan + 'まで あと' + remaining + '本！まとめ買いでお得に';
      modifier = '';
    } else if (pos === 5) {
      html     = 'あと1本追加で' + cycle + '本分割引 ' + amountSpan;
      modifier = 'vape-qty-promo--hot';
    } else {
      // pos === 6
      html     = cycle + '本分割引 ' + amountSpan + ' 適用済み';
      modifier = 'vape-qty-promo--done';
    }

    el.innerHTML  = html;
    el.className  = 'vape-qty-promo' + (modifier ? ' ' + modifier : '');
    el.style.display = '';
  }

  /**
   * STEP3-B 数量カウンター下の割引バナー
   * discountCount > 0 のときのみ表示
   */
  function renderQtyDiscountBanner() {
    var banner = document.getElementById('vapeQtyDiscountBanner');
    var label  = document.getElementById('vapeQtyDiscountLabel');
    var sub    = document.getElementById('vapeQtyDiscountSub');
    if (!banner) return;

    if (state.purchaseType !== 'one_time') {
      banner.style.display = 'none';
      return;
    }

    var discount = getDiscountCount(state.quantity);
    if (discount <= 0) {
      banner.style.display = 'none';
      return;
    }

    banner.style.display = '';
    if (label) label.textContent = discount + '本分の割引が適用されます！';
    if (sub)   sub.innerHTML   =
      formatMoney(discount * state.variantPrice) + ' 引き（6本ごとに1本無料）';
  }

  /* ------------------------------------------------------------------
     STEP 3 完了時の共通処理
  ------------------------------------------------------------------ */
  function onStep3Complete() {
    trimFlavorCounts();
    renderFlavorGrid();
    renderFlavorCounter();
    renderPrice();
    renderAddToCartState();
  }

  /* ------------------------------------------------------------------
     ステップリセットヘルパー
  ------------------------------------------------------------------ */
  /** ラジオグループのアクティブ状態をリセット */
  function resetRadioGroup(groupId) {
    var group = document.getElementById(groupId);
    if (!group) return;
    group.querySelectorAll('.vape-radio-card').forEach(function (c) {
      c.classList.remove('is-active');
      c.querySelector('input').checked = false;
    });
  }

  /** プランボタンのアクティブ状態をリセット */
  function resetPlanButtons() {
    var group = document.getElementById('vapeSubPlanGroup');
    if (!group) return;
    group.querySelectorAll('.vape-plan-btn').forEach(function (b) {
      b.classList.remove('is-active');
    });
  }

  /* ------------------------------------------------------------------
     フレーバーグリッド描画
  ------------------------------------------------------------------ */
  function renderFlavorGrid() {
    var grid = document.getElementById('vapeFlavorGrid');
    if (!grid) return;

    var stockKeys    = Object.keys(state.stockData);
    if (!stockKeys.length) {
      grid.innerHTML = '<p style="font-size:1.4rem;color:#999;padding:10px 0;">フレーバー情報を読み込み中...</p>';
      return;
    }

    var selectedTotal  = getFlavorSelectedCount();
    var limit          = getEffectiveQty();
    var isLimitReached = selectedTotal >= limit;

    var html = stockKeys.map(function (key) {
      var stock   = state.stockData[key];
      var inStock = typeof stock === 'number' && stock > 0;
      var count   = state.flavorCounts[key] || 0;
      var config  = FLAVOR_CONFIG[key] || { label: key.replace(/_/g, ' ').toUpperCase() };

      var cardClasses = ['vape-flavor-card'];
      if (count > 0)                        cardClasses.push('is-selected');
      if (!inStock)                         cardClasses.push('is-soldout');
      else if (isLimitReached && count === 0) cardClasses.push('is-disabled');

      var stockBadge = inStock
        ? '<span class="vape-flavor-stock in-stock">在庫あり</span>'
        : '<span class="vape-flavor-stock out-of-stock">在庫なし</span>';

      var minusDisabled = count <= 0               ? 'disabled' : '';
      var plusDisabled  = !inStock || isLimitReached ? 'disabled' : '';

      return (
        '<div class="' + cardClasses.join(' ') + '" data-flavor="' + key + '">' +
          '<div class="vape-flavor-card-top">' +
            '<span class="vape-flavor-color product-flavor-color"></span>' +
            '<span class="vape-flavor-name">' + config.label + '</span>' +
            stockBadge +
          '</div>' +
          '<div class="vape-flavor-stepper">' +
            '<button class="vape-flavor-minus" data-flavor-key="' + key + '" type="button" aria-label="' + config.label + ' を減らす" ' + minusDisabled + '>−</button>' +
            '<span class="vape-flavor-count">' + count + '</span>' +
            '<button class="vape-flavor-plus" data-flavor-key="' + key + '" type="button" aria-label="' + config.label + ' を増やす" ' + plusDisabled + '>＋</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    grid.innerHTML = html;

    // イベント委譲
    grid.querySelectorAll('.vape-flavor-minus, .vape-flavor-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var key   = btn.dataset.flavorKey;
        var delta = btn.classList.contains('vape-flavor-plus') ? 1 : -1;
        changeFlavor(key, delta);
      });
    });

    renderFlavorCounter();
  }

  function changeFlavor(key, delta) {
    var current = state.flavorCounts[key] || 0;
    var next    = current + delta;
    if (delta > 0 && getFlavorSelectedCount() >= getEffectiveQty()) return;
    if (next < 0) return;
    if (next === 0) delete state.flavorCounts[key];
    else            state.flavorCounts[key] = next;

    renderFlavorGrid();
    renderFlavorSummary();
    renderAddToCartState();
  }

  function renderFlavorCounter() {
    var elSelected = document.getElementById('vapeFlavorSelected');
    var elTotal    = document.getElementById('vapeFlavorTotal');
    var elCounter  = document.getElementById('vapeFlavorCounter');
    if (!elSelected || !elTotal || !elCounter) return;

    var selected   = getFlavorSelectedCount();
    var limit      = getEffectiveQty();
    elSelected.textContent = selected;
    elTotal.textContent    = limit;
    elCounter.classList.toggle('is-complete', limit > 0 && selected === limit);
  }

  /** フレーバー合計が有効数量を超えないよう調整 */
  function trimFlavorCounts() {
    var limit = getEffectiveQty();
    var total = getFlavorSelectedCount();
    if (total <= limit) return;
    var keys   = Object.keys(state.flavorCounts);
    var excess = total - limit;
    for (var i = keys.length - 1; i >= 0 && excess > 0; i--) {
      var key      = keys[i];
      var removable = Math.min(state.flavorCounts[key], excess);
      state.flavorCounts[key] -= removable;
      excess -= removable;
      if (state.flavorCounts[key] === 0) delete state.flavorCounts[key];
    }
  }

  /* ------------------------------------------------------------------
     フレーバーまとめ描画
  ------------------------------------------------------------------ */
  function renderFlavorSummary() {
    var el     = document.getElementById('vapeFlavorSummary');
    var elList = document.getElementById('vapeFlavorSummaryList');
    if (!el || !elList) return;

    var keys = Object.keys(state.flavorCounts).filter(function (k) {
      return state.flavorCounts[k] > 0;
    });

    if (!keys.length) { el.style.display = 'none'; return; }

    el.style.display = '';
    elList.innerHTML = keys.map(function (key) {
      var count  = state.flavorCounts[key];
      var config = FLAVOR_CONFIG[key] || { label: key.replace(/_/g, ' ').toUpperCase() };
      return (
        '<li class="vape-flavor-summary-item" data-flavor="' + key + '">' +
          '<span class="vape-flavor-summary-dot product-flavor-color"></span>' +
          config.label + ' × ' + count +
        '</li>'
      );
    }).join('');
  }

  /* ------------------------------------------------------------------
     価格表示
  ------------------------------------------------------------------ */
  function renderPrice() {
    var elTotal         = document.getElementById('vapePriceTotal');
    var elOriginalRow   = document.getElementById('vapePriceOriginalRow');
    var elOriginal      = document.getElementById('vapePriceOriginal');
    var elDiscountRow   = document.getElementById('vapePriceDiscountRow');
    var elDiscountCount = document.getElementById('vapeDiscountCountText');
    var elDiscount      = document.getElementById('vapePriceDiscount');
    var elUnitPriceWrap = document.getElementById('vapeUnitPrice');
    var elUnitPriceVal  = document.getElementById('vapeUnitPriceVal');

    if (!elTotal) return;

    var price = state.variantPrice;
    if (!price) {
      elTotal.textContent = '―';
      if (elOriginalRow) elOriginalRow.style.display = 'none';
      if (elDiscountRow) elDiscountRow.style.display = 'none';
      if (elUnitPriceWrap) elUnitPriceWrap.style.display = 'none';
      return;
    }

    if (state.purchaseType === 'subscription') {
      // 定期購入: 固定プライスを SUB_PRICES から取得して表示
      var planKey  = state.concentration + '-' + state.subPlan;
      var planYen  = state.subPlan ? (SUB_PRICES[planKey] || 0) : 0;
      elTotal.innerHTML = planYen > 0
        ? '<span class="price-currency">¥</span>' + planYen.toLocaleString('ja-JP')
        : '―';
      if (elOriginalRow) elOriginalRow.style.display = 'none';
      if (elDiscountRow) elDiscountRow.style.display = 'none';
      if (elUnitPriceWrap) elUnitPriceWrap.style.display = 'none';
    } else {
      // 単品購入: 割引ロジック適用
      var qty      = state.quantity;
      var discount = getDiscountCount(qty);
      var original = qty * price;
      var total    = calcPayableTotal(qty, price);

      elTotal.innerHTML = formatMoney(total);

      if (discount > 0) {
        // 通常価格（取り消し線）
        if (elOriginalRow) elOriginalRow.style.display = '';
        if (elOriginal)    elOriginal.innerHTML = formatMoney(original);

        // 割引額（赤字）
        if (elDiscountRow) elDiscountRow.style.display = '';
        if (elDiscountCount) {
          elDiscountCount.textContent = discount + '本分の割引が適用されています';
        }
        if (elDiscount) {
          elDiscount.innerHTML = '−' + formatMoney(discount * price);
        }
      } else {
        if (elOriginalRow) elOriginalRow.style.display = 'none';
        if (elDiscountRow) elDiscountRow.style.display = 'none';
      }

      if (elUnitPriceWrap) {
        elUnitPriceWrap.style.display = '';
        if (elUnitPriceVal) elUnitPriceVal.innerHTML = formatMoney(price);
      }
    }

    /* インライン単価（数量カウンター横） */
    var inlineWrap    = document.getElementById('vapeUnitPriceInline');
    var inlineBase    = document.getElementById('vapeUnitPriceBase');
    var inlineActual  = document.getElementById('vapeUnitPriceActual');
    var inlineActVal  = document.getElementById('vapeUnitPriceActualValue');

    if (inlineWrap) {
      if (state.purchaseType === 'subscription') {
        inlineWrap.style.display = 'none';
      } else {
        inlineWrap.style.display = '';
        var unitYen = SINGLE_UNIT_PRICES[state.concentration] || 0;
        if (inlineBase) inlineBase.innerHTML = '<span class="product-unit-price-value en">' + formatMoney(unitYen * 100) + '</span> / 本';

        var qty2      = state.quantity;
        var disc2     = getDiscountCount(qty2);
        if (disc2 > 0 && inlineActual && inlineActVal) {
          var discAmt2    = unitYen * disc2;
          var actualUnit2 = Math.floor((unitYen * qty2 - discAmt2) / qty2);
          inlineActVal.innerHTML = formatMoney(actualUnit2 * 100);
          inlineActual.style.display = '';
        } else if (inlineActual) {
          inlineActual.style.display = 'none';
        }
      }
    }
  }

  /* ------------------------------------------------------------------
     カートボタン状態
  ------------------------------------------------------------------ */
  function renderAddToCartState() {
    var btn    = document.getElementById('vapeAddToCartBtn');
    var note   = document.getElementById('vapeCartNote');
    if (!btn) return;

    var effectiveQty   = getEffectiveQty();
    var selectedCount  = getFlavorSelectedCount();
    var isFlavorReady  = effectiveQty > 0 && selectedCount === effectiveQty;
    var isVariantReady = !!state.variantId && state.variantAvailable;
    var isReady        = isFlavorReady && isVariantReady;

    btn.disabled = !isReady;

    var msg = '';
    if (!state.variantId) {
      msg = '';
    } else if (!state.variantAvailable) {
      msg = '選択中のバリアントは現在在庫がありません。';
    } else if (!isFlavorReady) {
      var remaining = effectiveQty - selectedCount;
      msg = 'フレーバーをあと ' + remaining + ' 本分選択してください。';
    }
    if (note) note.textContent = msg;
  }

  /* ------------------------------------------------------------------
     カートに追加
  ------------------------------------------------------------------ */
  function initAddToCart() {
    var btn = document.getElementById('vapeAddToCartBtn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      addToCart();
    });
  }

  function addToCart() {
    var btn     = document.getElementById('vapeAddToCartBtn');
    var btnText = btn.querySelector('.vape-btn-text');
    var btnLoad = btn.querySelector('.vape-btn-loading');

    btn.disabled = true;
    if (btnText) btnText.style.display = 'none';
    if (btnLoad) btnLoad.style.display = '';

    var cartQty    = getCartQty();          // 定期: 1 / 単品: 選択本数
    var flavorQty  = getEffectiveQty();     // フレーバー展開はプラン本数ベース
    var properties = buildCartProperties(flavorQty);

    var cartBody = { id: state.variantId, quantity: cartQty, properties: properties };

    if (state.purchaseType === 'subscription') {
      cartBody.selling_plan = MIKAWAYA_PLAN_ID;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type':     'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(cartBody),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'カートへの追加に失敗しました。');
          });
        }
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        var note = document.getElementById('vapeCartNote');
        if (note) note.textContent = err.message || 'エラーが発生しました。もう一度お試しください。';
      })
      .finally(function () {
        btn.disabled = false;
        if (btnText) btnText.style.display = '';
        if (btnLoad) btnLoad.style.display = 'none';
        renderAddToCartState();
      });
  }

  var FLAVOR_LABEL_MAP = {
    caramel: 'キャラメル',
    mix_berry: 'ミックスベリー',
    grape: 'グレープ',
    strong_menthol: 'ストロングメンソール',
    muscat: 'マスカット',
    lychee: 'ライチ',
    mango: 'マンゴー',
    strawberry: 'ストロベリー',
    green_apple: 'グリーンアップル',
    bear_mint: 'ベアミント',
  };

  function buildCartProperties(qty) {
    var props = {};

    // フレーバー集約（フレーバー名: X本）
    Object.keys(state.flavorCounts).forEach(function (key) {
      var count = state.flavorCounts[key];
      if (count > 0) {
        var label = FLAVOR_LABEL_MAP[key] || key;
        props[label] = count + '本';
      }
    });

    // 購入タイプ
    props['_購入タイプ'] = state.purchaseType === 'subscription' ? '定期購入' : '単品購入';

    // 単品割引情報
    if (state.purchaseType === 'one_time') {
      var discount = getDiscountCount(qty);
      if (discount > 0) props['_割引本数'] = discount + '本分';
    }

    // 定期プラン
    if (state.purchaseType === 'subscription' && state.subPlan) {
      props['_定期プラン'] = state.subPlan + '本/月';
    }

    return props;
  }

  /* ------------------------------------------------------------------
     初期化エントリーポイント
  ------------------------------------------------------------------ */
  function init() {
    // vapePage データがない場合は何もしない（他商品ページへの干渉防止）
    if (!window.vapePage) return;

    // デフォルト状態（CBD 5% / 定期購入）を初期適用
    applyStockData();
    applyResolvedVariant();

    /* ギャラリー初期化は gallery.js + product-vape.liquid 側で実行 */

    initConcentration();
    initPurchaseType();
    initSubPlan();
    initQuantity();
    initAddToCart();

    // 初期描画
    renderPlanSavings();
    renderFlavorGrid();
    renderFlavorCounter();
    renderPrice();
    renderAddToCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
